import React from 'react'

function index() {
  return (
    <div>Hello</div>
  )
}

export default index